import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {CABIN__24} from '@homeaway/svg-defs/lib/defs/CABIN__24';

export default React.forwardRef(({alt = ''}, ref) => {
    return (
        <div ref={ref} className={'CardCarousel__placeholderImage'} alt={alt} />
    );
});

export const PlaceholderSvg = () => (
    <div className="Placeholder__content">
        <SVGIcon markup={CABIN__24} />
    </div>
);
